"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormMultiSelect", {
    enumerable: true,
    get: function() {
        return FormMultiSelect;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _DropdownContainer = require("../../Dropdown/DropdownContainer");
const _AdminButton = require("../../Button/AdminButton");
const _Tags = require("../../Tags/Tags");
const _FormInputGroup = /*#__PURE__*/ _interop_require_wildcard(require("../FormInputGroup"));
const _FormInput = require("../FormInput/FormInput");
const _ri = require("react-icons/ri");
const _lodash = require("lodash");
const _SelectItem = require("../../SelectItem/SelectItem");
const _useAsRef = require("../../../util/useAsRef");
const _Option = require("./model/Option");
const _OnChange = require("./model/OnChange");
const _FormFacadeButtonGhost = require("./FormFacadeButtonGhost");
const _localisationeq1 = require("@equiem/localisation-eq1");
const _FormFacadeSimple = require("./FormFacadeSimple");
const _ProgressCircle = require("../../ProgressCircle/ProgressCircle");
const _hooks = require("../../../hooks");
const _FormFacadeSummary = require("./FormFacadeSummary");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useDropdownChevronBackground = require("../../../hooks/useDropdownChevronBackground");
const _stringNotEmpty = require("../../../util/stringNotEmpty");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const NO_GROUP = "__NO_GROUP__";
const MultiSelectInput = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { name, className, localValue, options, danger = false, setLocalValue, onChange, size, placeholder, emptyLabel, variant, noBorder = false, disabled = false, maxHeight = "220px" } = param;
    const onChangeRef = (0, _useAsRef.useAsRef)(onChange);
    const { colors, focusOutline, spacers } = (0, _Theme.useTheme)();
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        showBorder: !noBorder
    });
    const dropdownBg = (0, _useDropdownChevronBackground.useDropdownChevronBackground)({
        color: colors.grayscale[100]
    });
    const contentDanger = danger ? 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTUnIGhlaWdodD0nMTUnIHZpZXdCb3g9JzAgMCAxNCAxNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNNy4wMDAxNiAxMy42NjY2QzMuMzE4MTYgMTMuNjY2NiAwLjMzMzQ5NiAxMC42ODE5IDAuMzMzNDk2IDYuOTk5OTJDMC4zMzM0OTYgMy4zMTc5MiAzLjMxODE2IDAuMzMzMjUyIDcuMDAwMTYgMC4zMzMyNTJDMTAuNjgyMiAwLjMzMzI1MiAxMy42NjY4IDMuMzE3OTIgMTMuNjY2OCA2Ljk5OTkyQzEzLjY2NjggMTAuNjgxOSAxMC42ODIyIDEzLjY2NjYgNy4wMDAxNiAxMy42NjY2Wk03LjAwMDE2IDEyLjMzMzNDOC40MTQ2NSAxMi4zMzMzIDkuNzcxMiAxMS43NzEzIDEwLjc3MTQgMTAuNzcxMkMxMS43NzE2IDkuNzcwOTYgMTIuMzMzNSA4LjQxNDQxIDEyLjMzMzUgNi45OTk5MkMxMi4zMzM1IDUuNTg1NDMgMTEuNzcxNiA0LjIyODg4IDEwLjc3MTQgMy4yMjg2OEM5Ljc3MTIgMi4yMjg0OSA4LjQxNDY1IDEuNjY2NTkgNy4wMDAxNiAxLjY2NjU5QzUuNTg1NjcgMS42NjY1OSA0LjIyOTEyIDIuMjI4NDkgMy4yMjg5MyAzLjIyODY4QzIuMjI4NzMgNC4yMjg4OCAxLjY2NjgzIDUuNTg1NDMgMS42NjY4MyA2Ljk5OTkyQzEuNjY2ODMgOC40MTQ0MSAyLjIyODczIDkuNzcwOTYgMy4yMjg5MyAxMC43NzEyQzQuMjI5MTIgMTEuNzcxMyA1LjU4NTY3IDEyLjMzMzMgNy4wMDAxNiAxMi4zMzMzWk02LjMzMzUgOC45OTk5Mkg3LjY2NjgzVjEwLjMzMzNINi4zMzM1VjguOTk5OTJaTTYuMzMzNSAzLjY2NjU4TDcuNjY2ODMgMy42NjY1OFY3LjY2NjU4SDYuMzMzNVYzLjY2NjU4WicgZmlsbD0nI0U2MDAwRScvPjwvc3ZnPg==")' : "";
    const emptyState = emptyLabel != null ? /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, emptyLabel) : /*#__PURE__*/ _react.default.createElement("span", {
        className: "mt-1 placeholder-text"
    }, placeholder);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        tabIndex: 0,
        className: _style.default.dynamic([
            [
                "d679cdbe366861d3",
                [
                    size === "small" ? "14px" : "19px",
                    size === "small" ? "34px" : "42px",
                    size === "small" ? "14px" : "16px",
                    colors.muted1,
                    maxHeight,
                    spacers.s2,
                    variant,
                    danger ? colors.danger : colors.blue[60],
                    4,
                    danger ? focusOutline.colors.error : colors.blue[10],
                    contentDanger,
                    dropdownBg,
                    disabled ? "none" : "block",
                    colors.grayscale[3]
                ]
            ]
        ]) + " " + "form-multi-select ".concat(disabled ? "disabled" : "", " input-custom d-flex ").concat(className !== null && className !== void 0 ? className : "", " ").concat(borderCss.className, " ").concat(noBorder ? "border-none" : "")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "d679cdbe366861d3",
                [
                    size === "small" ? "14px" : "19px",
                    size === "small" ? "34px" : "42px",
                    size === "small" ? "14px" : "16px",
                    colors.muted1,
                    maxHeight,
                    spacers.s2,
                    variant,
                    danger ? colors.danger : colors.blue[60],
                    4,
                    danger ? focusOutline.colors.error : colors.blue[10],
                    contentDanger,
                    dropdownBg,
                    disabled ? "none" : "block",
                    colors.grayscale[3]
                ]
            ]
        ]) + " " + "tags-container d-flex"
    }, localValue.length > 0 ? localValue.map((val)=>{
        const valOption = options.find((opt)=>opt.value === val);
        const optionDisabled = disabled || (valOption === null || valOption === void 0 ? void 0 : valOption.disabled) === true;
        return /*#__PURE__*/ _react.default.createElement("div", {
            tabIndex: 1,
            key: val,
            className: _style.default.dynamic([
                [
                    "d679cdbe366861d3",
                    [
                        size === "small" ? "14px" : "19px",
                        size === "small" ? "34px" : "42px",
                        size === "small" ? "14px" : "16px",
                        colors.muted1,
                        maxHeight,
                        spacers.s2,
                        variant,
                        danger ? colors.danger : colors.blue[60],
                        4,
                        danger ? focusOutline.colors.error : colors.blue[10],
                        contentDanger,
                        dropdownBg,
                        disabled ? "none" : "block",
                        colors.grayscale[3]
                    ]
                ]
            ]) + " " + "tag-wrapper"
        }, /*#__PURE__*/ _react.default.createElement(_Tags.Tag, {
            size: size,
            onClose: !optionDisabled ? ()=>{
                const newVal = localValue.filter((p)=>p !== val);
                setLocalValue(newVal);
                onChangeRef.current((0, _OnChange.onChangeObject)(name, newVal));
            } : undefined
        }, (0, _Option.optionLabel)(valOption, true)));
    }) : /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, emptyState))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "d679cdbe366861d3",
        dynamic: [
            size === "small" ? "14px" : "19px",
            size === "small" ? "34px" : "42px",
            size === "small" ? "14px" : "16px",
            colors.muted1,
            maxHeight,
            spacers.s2,
            variant,
            danger ? colors.danger : colors.blue[60],
            4,
            danger ? focusOutline.colors.error : colors.blue[10],
            contentDanger,
            dropdownBg,
            disabled ? "none" : "block",
            colors.grayscale[3]
        ]
    }, ".form-multi-select.__jsx-style-dynamic-selector{padding:.5rem;line-height:".concat(size === "small" ? "14px" : "19px", "!important;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;cursor:pointer;float:none;outline:none;width:100%;min-height:").concat(size === "small" ? "34px" : "42px", ";font-size:").concat(size === "small" ? "14px" : "16px", "!important;font-weight:400;color:").concat(colors.muted1, ";position:relative;background:white;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;max-height:").concat(maxHeight, ";overflow:auto}.tags-container.__jsx-style-dynamic-selector{gap:").concat(spacers.s2, ";-webkit-flex-wrap:").concat(variant, ";-ms-flex-wrap:").concat(variant, ";flex-wrap:").concat(variant, ";overflow:scroll;padding-right:1.5rem;-ms-overflow-style:none;scrollbar-width:none;width:100%}.tags-container.__jsx-style-dynamic-selector::-webkit-scrollbar{display:none}.input-custom.__jsx-style-dynamic-selector:focus{border:1px solid ").concat(danger ? colors.danger : colors.blue[60], "!important;-webkit-box-shadow:0px 0px 0px ", 4, "px ").concat(danger ? focusOutline.colors.error : colors.blue[10], "!important;-moz-box-shadow:0px 0px 0px ", 4, "px ").concat(danger ? focusOutline.colors.error : colors.blue[10], "!important;box-shadow:0px 0px 0px ", 4, "px ").concat(danger ? focusOutline.colors.error : colors.blue[10], "!important}.tags-container.__jsx-style-dynamic-selector:before{position:absolute;right:6px;z-index:1;top:0;bottom:0;height:1rem;margin:auto 0;background-position:center;float:right;content:").concat(contentDanger, '}.tags-container.__jsx-style-dynamic-selector:after,.border-none.__jsx-style-dynamic-selector .tags-container.__jsx-style-dynamic-selector:hover:after{content:"";position:absolute;top:2px;right:2px;width:1.5rem;height:85%;pointer-events:none;background:').concat(dropdownBg, " center center no-repeat;display:").concat(disabled ? "none" : "block", "}.border-none.__jsx-style-dynamic-selector .tags-container.__jsx-style-dynamic-selector:after{background:none}.error-tag.__jsx-style-dynamic-selector{margin-left:auto;z-index:4}.disabled.__jsx-style-dynamic-selector{background-color:").concat(colors.grayscale[3], "}")), borderCss.styles);
});
MultiSelectInput.displayName = "MultiSelectInput";
const ItemGroup = (param)=>{
    let { options, name, selected, expandAll = false, onChangeOne, onChangeAll } = param;
    const ungrouped = name === NO_GROUP;
    const [open, setOpen] = (0, _react.useState)(ungrouped || options.some((o)=>selected.includes(o.value)));
    const enabledOptions = (0, _react.useMemo)(()=>options.filter((o)=>o.disabled !== true), [
        options
    ]);
    const enabled = (0, _react.useMemo)(()=>enabledOptions.length > 0, [
        enabledOptions
    ]);
    const checked = (0, _react.useMemo)(()=>enabled && !enabledOptions.some((o)=>!selected.includes(o.value)), [
        enabled,
        enabledOptions,
        selected
    ]);
    const indeterminate = (0, _react.useMemo)(()=>!checked && enabledOptions.some((o)=>selected.includes(o.value)), [
        checked,
        enabledOptions,
        selected
    ]);
    (0, _react.useEffect)(()=>{
        setOpen(expandAll || ungrouped || options.some((o)=>selected.includes(o.value)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandAll
    ]);
    const items = options.map((option)=>{
        const isSelected = selected.find((val)=>val === option.value) != null;
        var _option_indeterminate;
        return /*#__PURE__*/ _react.default.createElement(_SelectItem.SelectItem, {
            role: "option",
            indeterminate: (_option_indeterminate = option.indeterminate) !== null && _option_indeterminate !== void 0 ? _option_indeterminate : false,
            key: option.value,
            selected: isSelected,
            label: (0, _Option.optionLabel)(option),
            disabled: option.disabled,
            className: ungrouped ? "" : "ml-6",
            onChange: (e)=>{
                onChangeOne({
                    value: option.value,
                    checked: e.target.checked
                });
            }
        });
    });
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, name === NO_GROUP ? items : /*#__PURE__*/ _react.default.createElement("div", {
        role: "group",
        "aria-label": name
    }, /*#__PURE__*/ _react.default.createElement(_SelectItem.SelectItem, {
        role: "presentation",
        selected: checked,
        indeterminate: indeterminate,
        disabled: !enabled,
        itemSuffix: /*#__PURE__*/ _react.default.createElement("span", {
            style: {
                pointerEvents: "none"
            }
        }, open ? /*#__PURE__*/ _react.default.createElement(_ri.RiArrowUpSLine, {
            size: 16
        }) : /*#__PURE__*/ _react.default.createElement(_ri.RiArrowDownSLine, {
            size: 16
        })),
        onClickContainer: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            setOpen(!open);
        },
        onChange: (e)=>{
            onChangeAll({
                checked: e.target.checked
            });
            if (e.target.checked) {
                setOpen(true);
            }
        },
        label: name
    }), open && items));
};
const FormMultiSelect = (param)=>{
    let { className, placeholder, options, value, defaultValue, onChange, onClose = ()=>undefined, disabled = false, size = "large", variant = "initial", facade = "input", enableSelectAll = false, searchPlaceholder, withSearch = true, searchLoading = false, hasMoreSearchResults = false, searchCb, name, emptyLabel, title, mobileView, maxHeight, showChrome } = param;
    const { t } = (0, _localisationeq1.useTranslation)();
    const onChangeRef = (0, _useAsRef.useAsRef)(onChange);
    const { colors } = (0, _Theme.useTheme)();
    var _ref;
    const [localValue, setLocalValue] = (0, _react.useState)((_ref = defaultValue !== null && defaultValue !== void 0 ? defaultValue : value) !== null && _ref !== void 0 ? _ref : []);
    const [width, setWidth] = (0, _react.useState)();
    const FILTER_DEBOUNCE_MS = 500;
    const [filterText, setFilterText] = (0, _react.useState)(null);
    const debouncedFilter = (0, _hooks.useDebounced)(filterText, FILTER_DEBOUNCE_MS);
    const [searching, setSearching] = (0, _react.useState)(false);
    // Handle the search callback when exist.
    (0, _react.useEffect)(()=>{
        searchCb === null || searchCb === void 0 ? void 0 : searchCb(debouncedFilter !== null && debouncedFilter !== void 0 ? debouncedFilter : "").finally(()=>setSearching(false));
    }, [
        debouncedFilter,
        searchCb
    ]);
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (ref.current == null) {
            return;
        }
        const resizeObserver = new ResizeObserver(()=>{
            var _ref_current;
            const newWidth = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.getBoundingClientRect().width;
            setWidth(newWidth);
        });
        resizeObserver.observe(ref.current);
        // eslint-disable-next-line consistent-return
        return ()=>resizeObserver.disconnect();
    }, []);
    (0, _react.useEffect)(()=>{
        if (value == null || localValue.length === value.length && localValue.sort().toString() === value.sort().toString()) {
            return;
        }
        setLocalValue(value);
    }, [
        localValue,
        value
    ]);
    const filteredOptions = (0, _react.useMemo)(()=>options.filter((opt)=>{
            return filterText != null && filterText !== "" ? (0, _lodash.includes)((0, _Option.optionSearchText)(opt).toLowerCase(), filterText.toLowerCase()) : true;
        }), [
        filterText,
        options
    ]);
    const allSelected = (0, _react.useMemo)(()=>{
        const optionsEnabled = filteredOptions.filter((v)=>v.disabled !== true);
        if (optionsEnabled.length === 0) {
            return false;
        }
        const localValueEnabled = localValue.filter((v)=>optionsEnabled.some((o)=>o.value === v));
        return optionsEnabled.length === localValueEnabled.length;
    }, [
        filteredOptions,
        localValue
    ]);
    const noErrorFormGroupContext = (0, _react.useMemo)(()=>({
            hasError: false,
            error: undefined
        }), []);
    const groupedFilteredOptions = (0, _react.useMemo)(()=>{
        return (0, _lodash.groupBy)((0, _lodash.sortBy)(filteredOptions, (o)=>{
            var _o_group;
            var _o_group_weight;
            return (_o_group_weight = (_o_group = o.group) === null || _o_group === void 0 ? void 0 : _o_group.weight) !== null && _o_group_weight !== void 0 ? _o_group_weight : -1;
        }), (o)=>{
            var _o_group;
            var _o_group_name;
            return (_o_group_name = (_o_group = o.group) === null || _o_group === void 0 ? void 0 : _o_group.name) !== null && _o_group_name !== void 0 ? _o_group_name : NO_GROUP;
        });
    }, [
        filteredOptions
    ]);
    return /*#__PURE__*/ _react.default.createElement("div", {
        className: "jsx-a719d9e77e9ff2cc" + " " + "".concat(disabled ? "disabled" : "", " multi-select-dropdown")
    }, /*#__PURE__*/ _react.default.createElement(_DropdownContainer.DropdownContainer, {
        placement: "bottom-start",
        trigger: /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, facade === "simple" && /*#__PURE__*/ _react.default.createElement(_FormFacadeSimple.FormFacadeSimple, {
            ref: ref,
            localValue: localValue,
            options: options,
            disabled: disabled,
            emptyLabel: emptyLabel !== null && emptyLabel !== void 0 ? emptyLabel : placeholder,
            className: className
        }), facade === "summary" && /*#__PURE__*/ _react.default.createElement(_FormFacadeSummary.FormFacadeSummary, {
            ref: ref,
            localValue: localValue,
            options: options,
            disabled: disabled,
            emptyLabel: emptyLabel !== null && emptyLabel !== void 0 ? emptyLabel : placeholder,
            className: className,
            showChrome: showChrome
        }), (facade === "input" || facade === "input-no-border") && /*#__PURE__*/ _react.default.createElement(MultiSelectInput, {
            noBorder: facade === "input-no-border",
            ref,
            className,
            localValue,
            options,
            onChange,
            setLocalValue,
            size,
            placeholder,
            variant,
            disabled,
            name,
            maxHeight,
            emptyLabel
        }), facade === "ghost" && /*#__PURE__*/ _react.default.createElement(_FormFacadeButtonGhost.FormFacadeButtonGhost, {
            placeholder: placeholder,
            className: className,
            size: size
        })),
        width: width,
        mobileView: mobileView,
        title: title,
        onClose: ()=>onClose(localValue)
    }, withSearch && /*#__PURE__*/ _react.default.createElement(_FormGroupContext.FormGroupContext.Provider, {
        value: noErrorFormGroupContext
    }, /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Group, {
        className: "mr-3 ml-3 mt-2 mb-4"
    }, /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Prefix, null, searching || searchLoading ? /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
        size: 15,
        style: {
            color: colors.muted1
        }
    }) : /*#__PURE__*/ _react.default.createElement(_ri.RiSearchLine, {
        color: colors.muted1,
        size: 15
    })), /*#__PURE__*/ _react.default.createElement(_FormInput.FormInput, {
        placeholder: searchPlaceholder !== null && searchPlaceholder !== void 0 ? searchPlaceholder : t("common.searchAttributes"),
        autoFocus: true,
        onChange: (e)=>{
            searchCb != null && setSearching(true);
            setFilterText(e.target.value);
        },
        className: "search-input",
        style: {
            userSelect: "none"
        },
        value: filterText !== null && filterText !== void 0 ? filterText : ""
    }), /*#__PURE__*/ _react.default.createElement(_FormInputGroup.Suffix, null, /*#__PURE__*/ _react.default.createElement(_ri.RiCloseCircleLine, {
        style: {
            display: filterText == null || filterText.length === 0 ? "none" : "block",
            cursor: "pointer"
        },
        onClick: ()=>setFilterText(""),
        color: colors.muted1,
        size: 15
    })))), enableSelectAll && filteredOptions.length > 0 && /*#__PURE__*/ _react.default.createElement("div", {
        className: "jsx-a719d9e77e9ff2cc"
    }, /*#__PURE__*/ _react.default.createElement(_AdminButton.AdminButton, {
        className: "mb-2",
        variant: "ghost",
        size: "sm",
        onClick: ()=>{
            let newValue;
            if (allSelected) {
                // Retain all selected options which are disabled.
                newValue = options.flatMap((o)=>o.disabled === true && localValue.includes(o.value) ? [
                        o.value
                    ] : []);
            } else {
                newValue = (0, _lodash.uniq)([
                    // Retain existing selected values.
                    ...localValue,
                    // Append all visible options which are not disabled.
                    ...filteredOptions.flatMap((o)=>o.disabled === true ? [] : [
                            o.value
                        ])
                ]);
            }
            setLocalValue(newValue);
            onChangeRef.current((0, _OnChange.onChangeObject)(name, newValue));
        }
    }, allSelected ? t("common.deselectAll") : t("common.selectAll"))), Object.entries(groupedFilteredOptions).map((param)=>{
        let [groupName, groupOptions] = param;
        return /*#__PURE__*/ _react.default.createElement(ItemGroup, {
            key: groupName,
            options: groupOptions,
            name: groupName,
            selected: localValue,
            expandAll: (0, _stringNotEmpty.stringNotEmpty)(filterText),
            onChangeOne: (e)=>{
                const newVal = e.checked ? [
                    ...localValue,
                    e.value
                ] : localValue.filter((p)=>p !== e.value);
                setLocalValue(newVal);
                onChangeRef.current((0, _OnChange.onChangeObject)(name, newVal));
            },
            onChangeAll: (param)=>{
                let { checked } = param;
                const enabledOptions = groupOptions.filter((o)=>o.disabled !== true);
                const newVal = checked ? (0, _lodash.uniq)([
                    ...localValue,
                    ...enabledOptions.map((o)=>o.value)
                ]) : localValue.filter((p)=>!enabledOptions.some((o)=>o.value === p));
                setLocalValue(newVal);
                onChangeRef.current((0, _OnChange.onChangeObject)(name, newVal));
            }
        });
    }), !searching && !searchLoading && filteredOptions.length === 0 && /*#__PURE__*/ _react.default.createElement("div", {
        className: "jsx-a719d9e77e9ff2cc" + " " + "text-center my-4"
    }, t("common.noOptions")), withSearch && !searching && !searchLoading && hasMoreSearchResults && filteredOptions.length > 0 && /*#__PURE__*/ _react.default.createElement("div", {
        className: "jsx-a719d9e77e9ff2cc" + " " + "text-center my-4"
    }, t("common.refineYourSearch"))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "a719d9e77e9ff2cc"
    }, "input.jsx-a719d9e77e9ff2cc{cursor:pointer}label.jsx-a719d9e77e9ff2cc{cursor:pointer}.disabled.jsx-a719d9e77e9ff2cc{pointer-events:none;opacity:.9!important}.search-input{padding:0px!important}"));
};

//# sourceMappingURL=FormMultiSelect.js.map